import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { Form, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { SolicitanteInspComponent } from './solicitante-insp/solicitante-insp.component';
import { Store } from '@ngrx/store';
import * as FormActions from '../../../reducers/actions/forms.actions';
import { ClaveUnicaService } from 'src/app/services/clave_unica.service';
import { PerfilComponent } from '../../perfil/perfil.component';
import { UserService } from 'src/app/services/user.service';


interface AppState {
  form: Form;
}

declare const swal: any;

@Component({
  selector: 'app-crear-inspeccion',
  templateUrl: './crear-inspeccion.component.html',
  styleUrls: ['./crear-inspeccion.component.css'],
  providers: [ClaveUnicaService, UserService]
})
export class CrearInspeccionComponent implements OnInit {
  ///EXPORTACION DE FORMGROUP////////////////
  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;
  thirdFormGroup: FormGroup;
  quarterFormGroup: FormGroup;
  resumenFormGroup: FormGroup;
  //////////////////////////////////////////
  isLinear = false;
  @ViewChild('solicitanteInsp') hijo: SolicitanteInspComponent;
  public rol = new FormControl("");
  public dir = new FormControl("");
  public num = new FormControl("");
  public identity
  displayedColumns: string[] = ["rol", "direccion", "actions"];

  constructor(

    private dialog: MatDialog,
    private _formBuilder: FormBuilder,
    private snackBar: MatSnackBar,
    private _router: Router,
    private store: Store<AppState>,
    private claveUnicaService: ClaveUnicaService,
    private _userService: UserService
  ) {

    this.identity = this._userService.getIdentity();

    this.firstFormGroup = this._formBuilder.group({
      rut: ["", [Validators.required]],
      dv: ["", [Validators.required]],
      mod_solicitante: this._formBuilder.group({
        nombre: ["", [Validators.required]],
        apellido_p: [""],
        apellido_m: [""],
        calle: ["", [Validators.required]],
        num: ["", [Validators.required]],
        complemento: [""],
        telefono: [""],
        cel: ["", [Validators.required]],
        ciudad: [""],
        comuna: [""],
        email: ["", [Validators.required, Validators.email]],
      }),
    });

    this.secondFormGroup = this._formBuilder.group({
      rol: this.rol,
      dir: this.dir,
      num: this.num,
    });

    this.thirdFormGroup = this._formBuilder.group({
    })
    this.quarterFormGroup = this._formBuilder.group({
    })
    this.resumenFormGroup = this._formBuilder.group({
    })


  }

  ngOnInit(): void {
  }


  cerrar_vista() {
    this._router.navigate([`/inicio`]);
  }


  async logout() {
    this.store.dispatch(new FormActions.FormUpdate('0', ''))
    sessionStorage.removeItem("identity-domCloud");
    sessionStorage.removeItem("token-domCloud");

    const response = await this.claveUnicaService.logoutClaveUnica()
    console.log('Deslogeo exitoso:', response);

    this.snackBar.open("Se ha cerrado sesión", "Cerrar", {
      duration: 3000,
    });
    this.back()
  }

  openPerfil() {
    this.dialog.open(PerfilComponent)
  }

  back() {
    this._router.navigate(['/inicio'])
  }

  
}
